import React, {useState} from "react";
import {useSelector} from "react-redux";
//Material UI Components
import {
    Grid,
    Menu,
    AppBar,
    Toolbar,
    MenuItem,
    useTheme,
    Typography,
    IconButton,
    useMediaQuery,
} from "@material-ui/core";
import {makeStyles} from "@material-ui/styles";
//Material UI Icons
import {IMAGES_PATH} from "assets/constants";
import MenuIcon from '@material-ui/icons/Menu';
import AccountCircleOutlinedIcon from '@material-ui/icons/AccountCircleOutlined';

const useStyles = makeStyles(theme => ({
    menuButton: {
        marginLeft: theme.spacing(0.5),
        color: '#FFF',
        '& span': {
            '& svg': {
                color: '#FFF'
            }
        }
    },
    appbar: {
        zIndex: theme.zIndex.modal
    },
    toolbarMargin: {
        ...theme.mixins.toolbar,
        marginBottom: '0.6em',
        [theme.breakpoints.down('md')]: {
            marginBottom: '0.5em',
        },
        [theme.breakpoints.down('xs')]: {
            marginBottom: '0.1em',
        },
    },
    headerTitle: {
        marginLeft: theme.spacing(3),
    },
    menuContainer: {
        zIndex: 1302
    },
    logo: {
        width: '3em',
        height: '3em'
    }
}));

export default function Header({toggleDrawer}) {
    const classes = useStyles();
    const theme = useTheme();
    const matchesXS = useMediaQuery(theme.breakpoints.down('xs'))


    const [anchorEl, setAnchorEl] = useState(null);
    const [openMenu, setOpenMenu] = useState(false);

    const {title} = useSelector(state => state.inbox);

    const handleMenuClick = (e) => {
        setOpenMenu(!openMenu);
        setAnchorEl(e.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
        setOpenMenu(false);
    };

    const handleLogout = () => {
        localStorage.clear();
        if (!matchesXS)
            window.location = `${URL}/customer/login`
        else
            window.location.reload();
        return false;
    };

    return (
        <AppBar position='fixed' className={classes.appbar}>
            <Toolbar disableGutters variant='dense'>
                <Grid item container alignItems='center'>
                    <IconButton className={classes.menuButton} onClick={toggleDrawer}>
                        <MenuIcon/>
                    </IconButton>
                    <img className={classes.logo} src={`${IMAGES_PATH}logo.png`} alt='logo'/>
                    <Typography variant='h6' className={classes.headerTitle}>
                        {title}
                    </Typography>
                </Grid>
                <IconButton className={classes.menuButton} onClick={handleMenuClick}>
                    <AccountCircleOutlinedIcon/>
                </IconButton>
            </Toolbar>
            <Menu
                className={classes.menuContainer}
                id='profile-menu'
                anchorEl={anchorEl}
                open={openMenu}
                onClick={handleClose}
                keepMounted>
                <MenuItem component="a" target="_blank" href={`${URL}/customer/account`}> My Account </MenuItem>
                <MenuItem onClick={handleLogout}> Logout </MenuItem>
            </Menu>
        </AppBar>
    )
};